import { Collapse } from "antd";
import UpdloaderDocumentMobileV2 from "../Updloader/UpdloaderDocumentMobileV2";
const { Panel } = Collapse;

const CollapseComponentMobileV2 = () => {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div
      className="documents-container-mobile-v2"
      style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
    >
      <Collapse
        // defaultActiveKey={["1"]}
        onChange={onChange}
        style={{ marginTop: 40 }}
      >
        <Panel
          header="ADMISSION FORMS"
          key="1"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          <UpdloaderDocumentMobileV2
            repository="AdmissionForms"
            inputId="AdmissionForms"
          />
        </Panel>

        <Panel
          header="CLINICAL DOCUMENTS"
          key="2"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          <UpdloaderDocumentMobileV2
            repository="ClinicalDocuments"
            inputId="ClinicalDocuments"
          />
        </Panel>
        <Panel
          header="PROGRAM MANUALS"
          key="3"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          <UpdloaderDocumentMobileV2
            repository="ProgramManuals"
            inputId="ProgramManuals"
          />
        </Panel>

        <Panel
          header="INFORMATION TECHNOLOGY"
          key="4"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          <UpdloaderDocumentMobileV2
            repository="InformationTechnology"
            inputId="InformationTechnology"
          />
        </Panel>

        <Panel
          header="SALES & MARKETING"
          key="5"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          <UpdloaderDocumentMobileV2
            repository="SalesMarketing"
            inputId="SalesMarketing"
          />
        </Panel>
      </Collapse>
    </div>
  );
};
export default CollapseComponentMobileV2;
